import { getFabricSellerTrustType } from '@/service/fabric-api'
import { create } from 'zustand'

export enum TrustType {
  // 全店托管
  All = 1,
  // 面料托管
  Fabric = 2,
  // 推广项目托管
  Promotion = 3,
  // 店铺管理托管
  Shop = 4,
  // 客户咨询托管
  Consult = 5,
}

export interface AuthInfo {
  productId: number
  productName: string
  skuId: number
  skuName: string
  productBeginTime: string
  productEndTime: string
  signStatus: number
  effect: number
  userLimit: number
  ipLimit: number
}

interface BaseStore {
  hasZXBrole: boolean
  authInfo: AuthInfo[]
  getAuthInfo: (data: AuthInfo[]) => Promise<void>
  trustTypeList: TrustType[]
  getSellerTrustType: () => void
}

export const useBaseStore = create<BaseStore>((set) => ({
  hasZXBrole: false,
  authInfo: [],
  getAuthInfo: async (data: AuthInfo[]) => {
    const hasZXBrole = data.some(
      (item) => item.productId === 25 && item.productEndTime && new Date(item.productEndTime) > new Date(),
    )
    set({ authInfo: data, hasZXBrole })
  },
  trustTypeList: [],
  getSellerTrustType: async () => {
    const trustType = await getFabricSellerTrustType()
    set({ trustTypeList: trustType?.trustType || [] })
  },
}))
